import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { PersonAddOutlined } from '@material-ui/icons';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import { CustomAlert } from 'libs/feature-one-tool/src/quote/components/customAlert';
import { CustomButton } from 'libs/feature-one-tool/src/quote/components/customButton';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';

export const AddBorrowerCard = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  const { borrowerInformationStore } = loanTypeStore;

  return (
    <CustomAlert
      severity="info"
      variant="outlined"
      action={
        <CustomButton
          size="medium"
          theme="blue"
          startIcon={<PersonAddOutlined />}
          testId="edit-borrower"
          onClick={() => borrowerInformationStore.addCoBorrower()}
        >
          ADD BORROWER
        </CustomButton>
      }
    >
      <AlertTitle>Add Additional Borrower(s)</AlertTitle>
      <ul>
        <li>
          Include any additional borrowers who must be presented on the loan.
        </li>
        <li>
          Any individuals listed in the entity must be included in the loan
          submission.
        </li>
      </ul>
    </CustomAlert>
  );
});
